













































































import { Component, Vue } from 'vue-property-decorator'
import { CohortModule } from "@/store/modules/cohort";
import { getCohorts } from "@/api/cohorts";
import {
  ICohortLab
} from "@/api/types";
import { getCohortLabs } from "@/api/cohortLabs";
import { EventBus } from "@/utils/eventBus";
import * as moment from 'moment';
import Pagination from "@/components/Pagination/index.vue";

@Component({
  name: 'CohortLabs',
  components: {Pagination}
})
export default class extends Vue {
  private tableKey = 0;
  private cohortLabs: ICohortLab[] = [];
  private selectedCohortLabs: ICohortLab[] = [];
  private filteredCohortLabs: ICohortLab[] = [];
  private paginatedCohortLabs: ICohortLab[] = [];
  private listLoading = true;
  private total = 0;
  private searchTerm: string = '';
  private cloneDialogVisible: boolean = false;
  private currentPage: number = 1;
  private perPage: number = 20;
  private cohortId: string = '';

  created() {
    this.getCohorts();
    this.getCohortLabs()
    EventBus.$on("cohort-labs-search", this.filterBySearch);
  }

  destroyed() {
    EventBus.$off("cohort-labs-search", this.filterBySearch);
  }

  get cohorts() {
    return CohortModule.cohorts;
  }

  private async getCohorts() {
    this.listLoading = true;
    await getCohorts({}).then((response: any) => {
      let data = response.data;
      CohortModule.SetCohorts(data);
    });
  }

  private filterBySearch(data: any) {
    this.searchTerm = data.value;
    this.filteredCohortLabs = this.filterBySearchTerm(this.cohortLabs);
    this.paginatedCohortLabs = this.paginateData(this.filteredCohortLabs);
  }

  private paginateData(cohortLabs: ICohortLab[]) {
    let start = (this.currentPage - 1) * this.perPage;
    let end = this.currentPage * this.perPage;
    return cohortLabs.slice(start, end);
  }

  private filterBySearchTerm(cohortLabs: ICohortLab[]) {
    let targetString: string = "";
    if (this.searchTerm != "") {
      return cohortLabs.filter((cl: ICohortLab) => {
        if (cl.cohort.name) {
          targetString = `${cl.cohort.name}${cl.lab.displayName}`
          return targetString.toLowerCase().includes(this.searchTerm.toLowerCase())
        }
        return false;
      });
    }
    return cohortLabs;
  }

  private async getCohortLabs() {
    this.listLoading = true;
    await getCohortLabs({}).then(
      (response: any) => {
        let data = response.data;
        this.cohortLabs = data;
        this.total = data.length;
        this.filterBySearch({value: ''});
        this.listLoading = false;
      },
      (error: any) => {
        console.log(error);
        this.listLoading = false;
      }
    );
  }

  private reloadCohortLabs() {
    this.getCohortLabs()
  }

  private handleCohortSelection(data: any) {
    this.getCohortLabs();
  }

  private openCloneDialog() {
    this.cloneDialogVisible = true;
  }

  private handleUpdate(row: any) {

  }

  private paginationChange(data: any) {
    this.currentPage = data.page;
    if (this.perPage !== data.limit) {
      this.currentPage = 1;
      this.perPage = data.limit;
    }
    this.filterBySearch({value: this.searchTerm});
  }
}
